import { render, staticRenderFns } from "./edition-card.vue?vue&type=template&id=64714736&scoped=true&"
import script from "./edition-card.vue?vue&type=script&lang=ts&"
export * from "./edition-card.vue?vue&type=script&lang=ts&"
import style0 from "./edition-card.vue?vue&type=style&index=0&id=64714736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64714736",
  null
  
)

export default component.exports